import React from 'react';
import './Termspage.css';
import Footer from './Footer';

const Termspage = () => {
  return (
    <>
    <div className="terms-container">
      <h1 className="terms-title">اتفاقية الإستخدام</h1>
      <div className="terms-content">
        <p>مقدّمة اتفاقية الاستخدام:</p>
        <p>
          متجرنا الالكتروني يرحّب بكم ويبلغكم بأنكم سوف تجدون أدناه الشروط والأحكام المُنظّمة لاستخدامكم لهذا المتجر وكافة الآثار القانونية التي تنتج عن إستخدامكم لخدمات المتجر عبر الشبكة العنكبوتية عبر هذه المنصة الالكترونية، حيث أن استخدام أي شخصٍ كان للمتجر سواءً كان مستهلكاً لخدمة أو لمنتج المتجر أو غير ذلك فإن هذا موافقة وقبول منه وهو بكامل أهليته المعتبرة شرعاً ونظاماً وقانوناً لكافة مواد وأحكام هذه الاتفاقية وهو تأكيد لالتزامكم بأنظمتها ولما ذُكر فيها، وتسري هذه الاتفاقية على جميع أنواع التعامل بين المستهلك وبين. وتعتبر هذه الاتفاقية سارية المفعول ونافذة بمجرد قيامكم بالموافقة عليها والبدء في التسجيل بالمتجر بموجب المادة العاشرة من نظام التعاملات الإلكترونية السعودي.
        </p>

        <h2>المادة الأولى - المقدّمة والتعريفات:</h2>
        <ul>
          <li>1- ( المتجر ) ويشمل هذا التعريف كافة أشكال المتجر على الشبكة العنكبوتية، سواءً كانت تطبيق إلكتروني، أو موقع الكتروني على الشبكة العنكبوتية، أو محل تجاري.</li>
          <li>2- ( المستهلك) الشخص الذي يتعامل بالتجارة الإلكترونية رغبةً في الحصول على المنتجات أو الخدمات التي يوفرها من المتجر عبر منصته الالكترونية.</li>
          <li>3- ( الاتفاقية ) يقصَد بهذه العبارة شروط وأحكام هذه الاتفاقية، والتي تحكم وتنظّم العلاقة فيما بين أطراف هذه الاتفاقية.</li>
        </ul>

        <h2>المادة الثانية - أهلية المستهلك القانونية:</h2>
        <ul>
          <li>1- يقر المستهلك بأنه ذا أهلية قانونية معتبرة شرعاً ونظاماً للتعامل مع المتجر، أو أن عمره لا يقل عن ثمانية عشرة عاماً.</li>
          <li>2- يوافق المستهلك بأنه في حال مخالفته لهذه المادة، فإنه يتحمّل تبعات هذه المخالفة أمام الغير.</li>
        </ul>

        <h2>المادة الثالثة - طبيعة التزام:</h2>
        <ul>
          <li>1- إن التزام المتجر تجاه المستهلكين أو المستهلكين هو توفير ( الخدمة أو المنتج ).</li>
          <li>2- قد يوفّر المتجر خدمات أخرى كخدمات ما بعد البيع أو غيرها من الخدمات ذات العلاقة، وذلك يعود لطبيعة ونوع ( الخدمة أو المنتج ) المطلوبة من المستهلك.</li>
        </ul>

        <h2>المادة الرابعة - ضوابط استخدام :</h2>
        <ul>
          <li>1- يلتزم المستهلك باستخدام المنصة الالكترونية الخاصة بالمتجر بما يتّفق مع الآداب العامة والأنظمة المعمول بها في المملكة العربية السعودية.</li>
          <li>2- يلتزم المستهلك عند شرائه لخدمة أو منتج من هذا المتجر ألا يستخدم هذه الخدمة أو المنتج بما يخالف الآداب العامة والأنظمة المعمول بها في المملكة العربية السعودية.</li>
        </ul>

        <h2>المادة الخامسة - الحسابات والتزامات التسجيل:</h2>
        <p>فور التقدم بطلب الانضمام إلى عضوية في هذا المتجر كمستخدم تكون ملتزماً بالإفصاح عن معلومات محددة واختيار اسم مستخدم وكلمة مرور سرية لاستعمالها عند الولوج لخدمات المتجر. وبذلك تكون قد وافقت على:</p>
        <ul>
          <li>1- أن تكون مسؤولاً عن المحافظة على سرية معلومات حسابك وسرية كلمة المرور.</li>
          <li>2- لن يكون المتجر بأي حال من الأحوال مسؤولاً عن أي خسارة قد تلحق بك نتيجة كشف معلومات اسم المستهلك أو كلمة الدخول.</li>
          <li>3- أنت تلتزم باستخدام حسابك بنفسك، وفي حال استخدام غيرك له فهذه قرينة على أنك قد فوّضته باستخدام المتجر باسمك.</li>
          <li>4- أنت تلتزم عند استخدام المتجر أن تستخدمه بكل جدية ومصداقية.</li>
          <li>5- أنت تلتزم بالإفصاح عن معلومات حقيقية وصحيحة ومحدثة.</li>
          <li>6- إن متجرنا يلتزم بالتعامل مع معلوماتك الشخصية وعناوين الاتصال بك بسريّة تامة.</li>
          <li>7- إذا تبيّن للمتجر بأنك أفصحت عن معلومات غير حقيقية فإن للمتجر الحق في إلغاء عضويتك.</li>
          <li>8- في حالة عدم الالتزام فإن لإدارة المتجر الحق في حجبك من الولوج لخدمات المتجر.</li>
        </ul>

        <h2>المادة السادسة - الاتصالات الإلكترونية ووسائل التواصل الرسمية:</h2>
        <ul>
          <li>1- يوافق أطراف هذه الاتفاقية على أن التواصل يتم عبر البريد الإلكتروني المسجّل في المنصّة.</li>
          <li>2- يوافق المستهلك على أن جميع الاتفاقيات والإعلانات التي تزود بها الكترونياً تقوم مقام مثيلاتها المكتوبة.</li>
          <li>3- يوافق المستهلك على إمكانية التواصل معه من خلال رسائل عامة ترد إلى كافة المستهلكين.</li>
        </ul>

        <h2>المادة السابعة - التعديلات على إتفاقية الإستخدام والرسوم:</h2>
        <ul>
          <li>1- في حال إلغاء أي مادة من هذه الاتفاقية فإن ذلك لا يؤثر على صلاحية باقي المواد.</li>
          <li>2- تُشكّل الاتفاقية آلية العمل والتفاهم بين (المستهلك) و( المتجر).</li>
          <li>3- قد يفرض المتجر رسومًا تعتمد على العروض أو ما تفرضه الدولة.</li>
          <li>4- يحتفظ المتجر بحقه في تعديل الرسوم أو النفقات.</li>
        </ul>

        <h2>المادة الثامنة – خدمات الدفع والسداد للمتاجر في المتجر:</h2>
        <ul>
          <li>1- يوفّر المتجر عبر شركائه نظام الدفع والسداد.</li>
          <li>2- يلتزم المتجر بتحديد السعر وفقاً للقيمة السوقية.</li>
          <li>3- يلتزم المتجر بتوفير فواتير وسندات.</li>
          <li>4- يلتزم المتجر بتوفير المواصفات المحاسبية المعروفة.</li>
        </ul>

        <h2>المادة التاسعة – الملكية الفكرية:</h2>
        <ul>
          <li>1- إن حقوق الملكية الفكرية الخاصة بالمتجر هي مملوكة للمتجر ملكية تامة.</li>
          <li>2- يحترم المستهلك حقوق الملكية الفكرية الخاصة بالمتجر.</li>
        </ul>

        <h2>المادة العاشرة - مسؤولية المتجر:</h2>
        <ul>
          <li>1- يلتزم المتجر بالعمل وفق الأنظمة المعمول بها.</li>
          <li>2- المتجر لا يتحمل أي مطالبات عن أخطاء أو إهمال.</li>
          <li>3- يلتزم المتجر بأن يكون المنتج أو الخدمة سليمة ومصرح بها.</li>
        </ul>

        <h2>المادة الحادية عشر - تقييد الولوج أو العضوية:</h2>
        <p>يمكن للمتجر وقف أو إلغاء عضوية المستهلك أو تقييد ولوجه في أي وقت دون إنذار.</p>

        <h2>المادة الثانية عشر - القانون أو النظام الواجب التطبيق:</h2>
        <p>اتفاقية الاستخدام هذه محكومة بالقوانين المعمول بها في المملكة العربية السعودية.</p>

        <h2>المادة الثالثة عشر- أحكام عامة:</h2>
        <ul>
          <li>1- اللغة العربية هي اللغة المعتمدة لتفسير الاتفاقية.</li>
          <li>2- الأسعار قد تعدّل بين حينٍ وآخر.</li>
          <li>3- العروض الترويجية مؤقتة وقابلة للتعديل.</li>
          <li>4- يلتزم الأطراف بما لا يخالف القوانين والأنظمة.</li>
          <li>5- لا تُلغى الاتفاقية إلا بقرار من إدارة المتجر.</li>
        </ul>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Termspage;
